import { render, staticRenderFns } from "./line.vue?vue&type=template&id=741d7696&scoped=true&"
import script from "./line.vue?vue&type=script&lang=js&"
export * from "./line.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741d7696",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsSeguroEmpateMark: require('/var/web/bet777.es/components/elements/seguro-empate-mark.vue').default,EventTime: require('/var/web/bet777.es/components/event_time.vue').default,BetslipMoney: require('/var/web/bet777.es/components/betslip/money.vue').default,ElementsSeguroEmpateToggle: require('/var/web/bet777.es/components/elements/seguro-empate-toggle.vue').default})
